// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__19_PT","footer":"ModalUpdate_footer__DjpqV"};